import { connect } from 'react-redux';
import LoyaltySection from './loyalty_section';
import withPGTranslation from '../../../../config/withPGTranslation';

const mapStateToProps = ({ user: { user } }, { ...sectionProps }) => (
  {
    progress: user && user.loyaltyProgress,
    content: sectionProps.content
  }
);

export default connect(mapStateToProps, {})(withPGTranslation(LoyaltySection));
